import { Controller } from "@hotwired/stimulus"
import { rethrowUnlessAbort } from "../utils/fetch-error.util"

// Connects to data-controller="clipboard"
//
// Copies either the value of a `source` target (an input) or a literal `text` value, then confirms it twice for a
// moment: a check mark on the optional `icon` target (for people who see it) and the `copied` text in the optional
// `status` target, a role="status" live region kept outside the button (for people who hear it).
export default class extends Controller {
  static targets = ["source", "icon", "status"]
  static values = { text: String, copied: String }

  disconnect() {
    clearTimeout(this.restoreTimer)
  }

  copy() {
    const text = this.hasTextValue ? this.textValue : this.sourceTarget.value

    navigator.clipboard
      .writeText(text)
      .then(() => this.#flashCopied())
      .catch(rethrowUnlessAbort)
  }

  #flashCopied() {
    clearTimeout(this.restoreTimer)

    if (this.hasIconTarget) {
      this.iconTarget.dataset.original ||= this.iconTarget.textContent
      this.iconTarget.textContent = "check"
    }
    if (this.hasStatusTarget) this.statusTarget.textContent = this.copiedValue

    this.restoreTimer = setTimeout(() => this.#restore(), 1500)
  }

  #restore() {
    if (this.hasIconTarget) this.iconTarget.textContent = this.iconTarget.dataset.original
    if (this.hasStatusTarget) this.statusTarget.textContent = ""
  }
}
